export * from './ReceiptAnimatedWrapper';
